import script from "./EstramonioView.vue?vue&type=script&setup=true&lang=js"
export * from "./EstramonioView.vue?vue&type=script&setup=true&lang=js"

import "./EstramonioView.vue?vue&type=style&index=0&id=0553142d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0553142d"]])

export default __exports__